//@author: sean
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { S25EditablePropertyComponent } from "./s25.editable.property.component";
import { S25MultiselectModule } from "../s25-multiselect/s25-multiselect.module";
import { S25EditableModule } from "../s25-editable/s25.editable.module";
import { S25LoadingInlineModule } from "../s25-loading/s25.loading.inline.module";
import { S25IconButtonComponent } from "../../standalone/s25.icon.button.component";

@NgModule({
    declarations: [S25EditablePropertyComponent],
    imports: [
        CommonModule,
        FormsModule,
        S25MultiselectModule,
        S25EditableModule,
        S25LoadingInlineModule,
        S25IconButtonComponent,
    ],
    providers: [S25EditablePropertyComponent],
    exports: [S25EditablePropertyComponent],
})
export class S25EditablePropertyModule {}
